export default __webpack_public_path__ + "static/media/user-blue.d7e06643.svg";